import { Component } from '@angular/core';

@Component({
  selector: 'stc-apps-repository-icon',
  standalone: true,

  templateUrl: './repository-icon.component.svg',
  styleUrl: './repository-icon.component.scss',
})
export class RepositoryIconComponent {}
